var _g, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangswitchTwoBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 151.03,
    viewBox: "0 0 151.11 151.03",
    width: 151.11,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m98.24 12.59v55.38h-35.28a10.07 10.07 0 0 0 -10.07 10.07v5h-7.55l-23.7 17.15a2.5 2.5 0 0 1 -2.62.21 2.54 2.54 0 0 1 -1.38-2.24v-15.08h-5a10.07 10.07 0 0 1 -10.07-10.07v-60.42a10.07 10.07 0 0 1 10.07-10.08h75.5a10.07 10.07 0 0 1 10.1 10.08z",
    fill: "#bac2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.64 97.66v.5a2.54 2.54 0 0 0 1.38 2.25 2.5 2.5 0 0 0 2.62-.21l23.7-17.15h-7.56z",
    fill: "#8c9aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.34 78.04v5h7.55v-5a10.07 10.07 0 0 1 10.07-10.07h-7.55a10.07 10.07 0 0 0 -10.07 10.07z",
    fill: "#8c9aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.14 2.51h-7.56a10.07 10.07 0 0 1 10.07 10.08v55.38h7.59v-55.38a10.07 10.07 0 0 0 -10.1-10.08z",
    fill: "#8c9aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.56 78.04v60.43a10.07 10.07 0 0 1 -10.07 10.07h-75.53a10.07 10.07 0 0 1 -10.07-10.07v-60.43a10.07 10.07 0 0 1 10.07-10.07h42.8l23.69-17.14a2.52 2.52 0 0 1 2.63-.21 2.49 2.49 0 0 1 1.37 2.25v15.1h5a10.07 10.07 0 0 1 10.11 10.07z",
    fill: "#bac2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.49 67.97h-5v-15.1a2.49 2.49 0 0 0 -1.37-2.25 2.52 2.52 0 0 0 -2.63.21l-3.55 2.57v14.57h5a10.07 10.07 0 0 1 10.07 10.07v60.43a10.07 10.07 0 0 1 -10.07 10.07h7.55a10.07 10.07 0 0 0 10.07-10.07v-60.43a10.07 10.07 0 0 0 -10.07-10.07z",
    fill: "#8c9aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.61 83.08h5v15.08a2.54 2.54 0 0 0 1.38 2.25 2.5 2.5 0 0 0 2.62-.21l3.63-2.54v-14.58h-5a10.07 10.07 0 0 1 -10.07-10.07v-60.42a10.07 10.07 0 0 1 10.07-10.08h-7.55a10.07 10.07 0 0 0 -10.07 10.08v60.42a10.07 10.07 0 0 0 9.99 10.07z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.02 52.87h5v20.14h-5z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.540003,
    cy: 62.939999,
    fill: "#27227d",
    r: 2.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m138.49 65.46h-2.52v-12.59a5 5 0 0 0 -8-4.08l-23 16.67h-4.23v-52.87a12.59 12.59 0 0 0 -12.58-12.59h-75.55a12.61 12.61 0 0 0 -12.59 12.59v40.28a2.52 2.52 0 1 0 5 0v-40.28a7.55 7.55 0 0 1 7.56-7.56h75.56a7.55 7.55 0 0 1 7.55 7.56v52.87h-32.73a12.6 12.6 0 0 0 -12.59 12.58v2.52h-5a2.54 2.54 0 0 0 -1.48.48l-23.73 17.12v-15.08a2.52 2.52 0 0 0 -2.52-2.52h-5a7.55 7.55 0 0 1 -7.56-7.55 2.52 2.52 0 1 0 -5 0 12.61 12.61 0 0 0 12.59 12.59h2.51v12.56a5 5 0 0 0 8 4.07l23-16.66h4.22v52.87a12.61 12.61 0 0 0 12.59 12.59h75.53a12.61 12.61 0 0 0 12.59-12.59v-60.4a12.6 12.6 0 0 0 -12.59-12.58zm7.55 73a7.55 7.55 0 0 1 -7.55 7.55h-75.53a7.55 7.55 0 0 1 -7.55-7.55v-60.42a7.55 7.55 0 0 1 7.55-7.55h42.8a2.54 2.54 0 0 0 1.48-.48l23.7-17.14v15.1a2.51 2.51 0 0 0 2.51 2.52h5a7.55 7.55 0 0 1 7.55 7.55z",
    fill: "#27227d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.62 61.3 5.05-13.47h15.4l5.05 13.47a2.52 2.52 0 0 0 2.36 1.64 2.63 2.63 0 0 0 .88-.16 2.47 2.47 0 0 0 1.41-1.32 2.51 2.51 0 0 0 .07-1.92l-15.11-40.29a2.52 2.52 0 0 0 -4.72 0l-15.1 40.29a2.5 2.5 0 0 0 .41 2.48 2.52 2.52 0 0 0 4.3-.72zm12.75-34 5.81 15.49h-11.62z",
    fill: "#27227d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m120.87 93.16h-17.63v-7.55a2.52 2.52 0 1 0 -5 0v7.55h-17.66a2.52 2.52 0 0 0 0 5h28.83a71.72 71.72 0 0 1 -9.91 15.28 50.29 50.29 0 0 1 -4.08-6.34 2.52 2.52 0 1 0 -4.5 2.26 54.89 54.89 0 0 0 5.13 7.91 67 67 0 0 1 -14.15 11.41 2.54 2.54 0 0 0 -1.32 2.15 2.52 2.52 0 0 0 3.71 2.28 69 69 0 0 0 15-11.91 52.49 52.49 0 0 0 15.42 11.96 2.5200496 2.5200496 0 0 0 2.25-4.51 47.79 47.79 0 0 1 -14.2-11.19 76.87 76.87 0 0 0 12.18-19.3h5.93a2.52 2.52 0 0 0 0-5z",
    fill: "#27227d",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.12 20.16v-5h5a2.52 2.52 0 1 0 0-5h-7.55a2.52 2.52 0 0 0 -2.52 2.52v7.48a2.52 2.52 0 1 0 5 0z",
    fill: "#27227d",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m138.49 128.4a2.52 2.52 0 0 0 -2.52 2.52v5h-5a2.52 2.52 0 0 0 0 5h7.55a2.52 2.52 0 0 0 2.52-2.52v-7.55a2.52 2.52 0 0 0 -2.55-2.45z",
    fill: "#27227d",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangswitchTwoBubbles);
export default __webpack_public_path__ + "static/media/langswitchTwoBubbles.ab99276e5628c895dcfbaaee2e310de0.svg";
export { ForwardRef as ReactComponent };